import Vue from 'vue'
// 全局引入
// import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

// Vue.use(Element)

// 按需导入
import {
  Menu,
  MenuItem,
  Carousel,
  CarouselItem,
  Row,
  Col,
  Card

} from 'element-ui'

Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Col)
